import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios.tsx";
import Input from "../../components/ui/input.tsx";
import Label from "../../components/ui/label.tsx";
import Button from "../../components/ui/button.tsx";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      // Placeholder: call your backend endpoint if available
      await api.post("/auth/password/forgot", { email });
      setSent(true);
    } catch (err: any) {
      console.error(err);
      setSent(true); // still show success-style state to avoid leaking emails
    }
  };

  return (
    <div className="page flex items-center justify-center p-4">
      <div className="w-full max-w-md p-8 card-glass relative z-10">
        <div className="text-center">
          <div className="eyebrow inline-block mb-4">Reset</div>
          <h1 className="heading-2 text-center text-glow">Forgot Password</h1>
          <p className="subheading">We’ll email you a reset link if your account exists.</p>
        </div>
        {sent ? (
          <div className="mt-6 text-white/90 text-center">
            Check your email for a password reset link.
            <div className="mt-4">
              <Button className="btn-primary" onClick={() => navigate("/auth")}>Back to sign in</Button>
            </div>
          </div>
        ) : (
          <form className="flex flex-col mt-6" onSubmit={onSubmit}>
            <Label htmlFor="email" className="mb-1">Email</Label>
            <Input id="email" type="email" placeholder="you@example.com" value={email} onChange={(e)=>setEmail(e.target.value)} required className="mb-3" />
            {error && <div className="text-red-400 text-sm" role="alert">{error}</div>}
            <Button type="submit" className="btn-primary w-full mt-2">Send reset link</Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;

